import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import FacebookProvider, { Like, Share } from 'react-facebook';


const FooterBottom = (props) => ( 
	<Container_s fluid>
		<Container_1000 >
			<Row_First>
				<Col_ContactHeader xs="12">
					<ContactLink to="/Contact">CONTACT US ></ContactLink>
					<hr />
				</Col_ContactHeader>
			</Row_First>
			<Row_Second>
				<Col_ContactInfo xs="12" md="6">
					<a target="_blank" href="https://www.google.com/maps/place/93+Germania+St,+Galeton,+PA+16922/@41.7319753,-77.6506319,17z/data=!3m1!4b1!4m5!3m4!1s0x89ce19f9457092e1:0xe0b43148ccbcf991!8m2!3d41.731971!4d-77.648443">
						93 Germania Street Galeton, PA 16922
					</a>
					
					{/*
					<Link to="/Store">
						<p>Browse our Candles ></p>
					</Link>
					*/
					}	

					<p>P: (814) 558-5764</p>
					<Email_p>E: <a href="mailto:primitivescandles@gmail.com">PrimitivesCandles@gmail.com</a></Email_p>
				</Col_ContactInfo>
				<Col_RightSide1 xs="12" md="6">

					<Button size="xl"><Link to="/Locator">Store Locations & Directions 	&#8599;</Link></Button>
				    <FacebookProvider appId="1920940231456325">
				      <Like href="https://www.facebook.com/Primitives-Candles-1616540168633493/" 
				        	colorScheme="dark" share width="290" />
				    </FacebookProvider>
				</Col_RightSide1>
			</Row_Second>
			<Row_Final>
				<Col className="col" xs="12" >
					<p>
						Primitives Candles &copy;{new Date().getFullYear()}. All Rights Reserved.
					</p>
						<span className="outer" 
							style={{width: "1.1px", height: "100%", borderLeft: "1.1px solid #b1934e", margin: "0 5px 0 5px"}}></span>
					<p>
						<Link to="/ShippingHandling">Return Policy</Link> 
						<span style={{width: "1.1px", height: "100%", borderLeft: "1.1px solid #b1934e", margin: "0 5px 0 5px"}}></span>
						<Link to="/FAQ">Privacy Policy</Link>
						<span style={{width: "1.1px", height: "100%", borderLeft: "1.1px solid #b1934e", margin: "0 5px 0 5px"}}></span>
                		<a href="https://s3.amazonaws.com/primitivescandlesstorage/sitemap.txt" target="_blank">Sitemap</a> 
					</p>
					
						<span className="outer" 
							style={{width: "1.1px", height: "100%", borderLeft: "1.1px solid #b1934e", margin: "0 5px 0 5px"}}></span>

					<p>
						Website Design by <a target="_blank" href="https://www.Lotus29.com">Lotus29</a>
					</p>
				</Col>
			</Row_Final>
		</Container_1000>
	</Container_s>
);

export default FooterBottom;

const Row_Final = styled(Row)`
	text-align: center;

	.col {
		padding: 0;

		p {
			margin: 0;
			display: block;

			a {
				color: #8A572A;
				:hover {
					color: #996633;
				}
			}
		}
		span.outer {
			display: none;
		}
		${media.md` 
			p {
				display: inline-block;
				
			}
			span.outer {
				display: inline;
			}
		`}
		${media.lg` font-size: 14px; `}
	}
`;

const Row_First = styled(Row)`
	margin: 0 0 15px 0;
`;
const Row_Second = styled(Row)`
	margin: 0 0 15px 0;
`;
const Email_p = styled.p`
	a {
		color: black;
		:hover {
			color: #996633;
		}
	}
`;
const Col_ContactHeader = styled(Col)`
	hr {
		border-color: #8A572A;
	}
`;
const Col_ContactInfo = styled(Col)`
	font-size: 14px;
	${media.lg` font-size: 16px; `}

	p {
		margin: 0;
	}

	a {
		color: #8A572A;

		:focus, :hover {
			outline: none;
			color: #8A572A;
		}
	}


`;
const ContactLink = styled(Link)`
	color: #8A572A;
	font-size: 24px;
	:hover {
		color: #996633;
	}
`;
const Col_RightSide1 = styled(Col)`
	font-size: 14px;
	button {
		background-color: #8B572A;
		font-size: 16px;
		${media.lg` font-size: 18px; `}
		border: none;
		height: 50px;
		margin: 15px 0 15px 0;
		cursor: pointer;

        :hover {
          background-color: #dfbf9f;
        }
        :focus {
          box-shadow: none;
        }
        :active {
          background-color: #dfbf9f;
        }

		a {
			color: white;
			:hover{
				color: white;
				text-decoration-line: none;
			}
			
		}
	}

	${media.md`
		button {
			margin: 0 0 15px 0;
		}
	`}

	
`;



const Container_s = styled(Container)`
	padding: 30px 0 40px 0!important;
	background-color: #D0C1A0;
`;

const Container_1000 = styled(Container)`
	font-size: 12px;
	background-color: #D0C1A0;

	div, span, p, a {
		font-family: "Raleway";
	}

	div {
		background-color: #D0C1A0;
	}
`;


// WEBPACK FOOTER //
// ./src/components/FooterBottom.js